import React, { useEffect, useState } from 'react';
import './App.css';
import twitterLogo from './assets/twitter-logo.svg';
import CandyMachine from './CandyMachine';
// Constants
const TWITTER_HANDLE = 'gayatri628';
const TWITTER_LINK = `https://twitter.com/${TWITTER_HANDLE}`;

const App = () => {
  // State
const [walletAddress, setWalletAddress] = useState(null);
  //events
  const checkIfWalletIsConnected = async () => {
  try {
    const { solana } = window;

    if (solana) {
      if (solana.isPhantom) {
        console.log('Phantom wallet found!');
        //to connect w user's wallet
        const response = await solana.connect({ onlyIfTrusted: true });
        console.log(
          'Connected with Public Key:',
          response.publicKey.toString()
        );
        setWalletAddress(response.publicKey.toString());
      }
    } else {
      alert('Solana object not found! Get a Phantom Wallet 👻');
    }
  } catch (error) {
    console.error(error);
  }
};

const connectWallet = async () => {
  const { solana } = window;

if (solana) {
  const response = await solana.connect();
  console.log('Connected with Public Key:', response.publicKey.toString());
  setWalletAddress(response.publicKey.toString());
}
};

/*
 * We want to render this UI when the user hasn't connected
 * their wallet to our app yet.
 */
const renderNotConnectedContainer = () => (
  <button
    className="cta-button connect-wallet-button"
    onClick={connectWallet}
  >
    Connect to Wallet
  </button>
);
/*
 * When our component first mounts, let's check to see if we have a connected
 * Phantom Wallet
 */
useEffect(() => {
  const onLoad = async () => {
    await checkIfWalletIsConnected();
  };
  window.addEventListener('load', onLoad);
  return () => window.removeEventListener('load', onLoad);
}, []);


  return (
    <div className="App">
      <div className="container">
        <div className="header-container">
          <p className="header">🐈 Kittycat Drop</p>
          <p className="sub-text">NFT drop machine with fair mint</p>
          {!walletAddress && renderNotConnectedContainer()}
          {walletAddress && <CandyMachine walletAddress={window.solana} />}
        </div>
        <div className="footer-container">
          <img alt="Twitter Logo" className="twitter-logo" src={twitterLogo} />
          <a
            className="footer-text"
            href={TWITTER_LINK}
            target="_blank"
            rel="noreferrer"
          >{`my twitter @${TWITTER_HANDLE}`}</a>
        </div>
      </div>
    </div>
  );
};

export default App;
